<template>
    <div class="f-topic-related-item">
        <div class="f-topic-related-item-blue"></div>
        <div class="f-topic-related-item-boardname">{{title}}</div>

        <ul class="f-topic-related-item-list">
            <li v-for="item in listData"
                :key="item[indexKey]"
                class="f-topic-related-item-list-item">
                <!-- 非文档链接 -->
                <a v-if="!item.from || item.from === 'devforum'"
                @click="navigatToTopic(item, routerKey)" :title="item.title">
                    <!-- 相关链接加前缀，注明是社区或文档 -->
                    <span class="f-topic-related-item-list-item-title">
                        <span v-if="type === 'link'" class="f-topic-related-item-list-item-title-link">【社区】</span>{{item.title}}
                    </span>
                    <span class="f-topic-related-item-list-item-process">
                        <span v-if="type === 'issue'">{{item.process | matchIssueProcess }}</span>
                        <span v-else-if="type === 'link'">{{item.replyCount}}条{{item.type === 2 ? '回答' : '回复'}}</span>
                        <span v-else>{{item[processKey]}}</span>
                    </span>
                </a>
                <!-- 文档链接 -->
                <a @click="navigateToSmart(item)" :title="item.title" v-else>
                    <span class="f-topic-related-item-list-item-title f-topic-related-item-list-item-title-link">【文档】{{ item.title }}</span>
                    <span class="f-topic-related-item-list-item-process">[{{ item.boardName }}]</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/related-board-item.less';
</style>

<script>
import {mapState} from 'vuex';

export default {
    props: {
        // type 指明特殊类型 issue/link
        type: String,
        // title 板块名
        title: String,
        // 需要遍历的数据
        listData: {
            'type': Array,
            'default': () => []
        },
        // title索引的key
        titleKey: {
            'type': String,
            'default': 'title'
        },
        // process索引的key
        processKey: {
            'type': String,
            'default': 'process'
        },
        indexKey: String,
        routerKey: String
    },
    computed: {
        ...mapState({
            relatedTypeMap: state => state.topicContent.relatedTypeMap
        })
    },
    methods: {
        navigatToTopic(item, routerKey) {
            if (item.type === 3 || routerKey === 'issueId') {
                _hmt.push([
                    '_trackEvent',
                    this.relatedTypeMap[this.type],
                    '社区',
                    `${this.origin}/forum/issue/show/${item.issueId}`
                ]);
                window.open(`/forum/issue/show/${item.issueId}`);
            } else {
                _hmt.push([
                    '_trackEvent',
                    this.relatedTypeMap[this.type],
                    '社区',
                    `${this.origin}/forum/topic/show/${item[routerKey]}`
                ]);
                window.open(`/forum/topic/show/${item[routerKey]}`);
            }
        },
        // sug文档内容打点上报至百度统计
        navigateToSmart(item) {
            _hmt.push(['_trackEvent', '相关链接', '文档', `${this.origin}${item.path}`]);
            window.open(item.path);
        }
    }
};
</script>